<template>
  <div class="decade-section" :id="anchor">
    <button
      @click="
        {
          scroll(anchor);
        }
      "
      :class="[
        'decade-section__anchor',
        {
          'fix-anchor-bottom': fixAnchor.bottom,
          'fix-anchor-top': fixAnchor.top,
          'hide-anchor': !containerInView,
        },
      ]"
      :id="'anchor-' + anchor"
      :style="{
        '--fixed-distance-bottom': getAnchorBottomOffset(index),
        '--fixed-distance-top': getAnchorTopOffset(index),
      }"
    >
      {{ formatAnchor(anchor) }}
    </button>
    <ul
      ref="anchorEl"
      :class="[
        'decade-section__list',
        { column: $route.query.disposition == 'columns' },
      ]"
      :id="'box-decade-' + anchor"
    >
      <YearBox
        v-for="(year, index) in decade"
        :key="index + '-box'"
        :year="year"
        :decade="anchor"
      />
    </ul>
    <template v-if="props.index === 0">
      <svg
        class="decade-section__background"
        width="100%"
        height="150"
        :transform="`translate(0, ${
          (120 + ($tvaMq === 'desktop' ? 29 : $tvaMq === 'tablet' ? 27 : 6)) *
            lineIndex +
          ($tvaMq === 'mobile' ? 3 : 12)
        })`"
        v-for="(line, lineIndex) in new Array(
          $tvaMq === 'desktop' ? 20 : $tvaMq === 'tablet' ? 40 : 80
        )"
        :key="lineIndex"
      >
        <line
          x1="0"
          y1="0"
          x2="100%"
          y2="0"
          fill="none"
          stroke="var(--scala-grigi-gray-3)"
          stroke-width=".3"
        />
      </svg>
    </template>
  </div>
</template>

<script setup>
import YearBox from "./YearBox.vue";
import { useRoute, useRouter } from "vue-router";
import { watch, inject, ref, computed } from "vue";
import { useElementBounding } from "@vueuse/core";
import { useI18n } from "vue-i18n";

const props = defineProps({
  decade: Array,
  anchor: Number,
  anchors: Array,
  index: Number,
  containerTop: Number,
  containerHeight: Number
});

// const emit = defineEmits(["anchorInView", "removeAnchorFromView"]);

const route = useRoute();
const router = useRouter();
const $tvaMq = inject("$tvaMq");

const anchorEl = ref(null);
const fixAnchor = ref({ top: false, bottom: false });
const containerInView = ref(false);
const { t } = useI18n();
// const queryChangingActive = ref(true); // We don't want the params to change when scrolling from click
const anchorPadding = 8;

const topAnchorsPadding = computed(() =>
  $tvaMq.value === "mobile" || $tvaMq.value === "tablet" ? 47 : 64
);
const bottomAnchorsPadding = computed(() =>
  $tvaMq.value === "mobile" ? 70 : 50
);
const titleHeight = computed(() => ($tvaMq.value === "mobile" ? 162 : 152));
const anchorHeight = computed(
  () => ($tvaMq.value === "mobile" ? 23 : 19) + anchorPadding
);
// Returns top relative to window top
const { top } = useElementBounding(anchorEl);

const totalHeightAnchorsBottom = computed(
  () => props.anchors.length * anchorHeight.value
);

watch(
  () => props.containerTop,
  (containerTop) => {
    const anchorTop = top.value;

    containerInView.value =
      (containerTop <
      window.innerHeight - totalHeightAnchorsBottom.value - titleHeight.value) && props.containerTop - window.innerHeight / 2 + props.containerHeight > 0;

    const isBelowBottom =
      anchorTop >
      window.innerHeight -
        totalHeightAnchorsBottom.value +
        anchorHeight.value * (props.index - ($tvaMq === "mobile" ? 3 : 2));

    const isAboveTop =
      anchorTop <
      0 + topAnchorsPadding.value + anchorHeight.value * (props.index + 2);

    if (containerInView.value) {
      // const anchorWasInView = !fixAnchor.value.bottom && !fixAnchor.value.top;

      fixAnchor.value.bottom = isBelowBottom;
      fixAnchor.value.top = isAboveTop;

      // const anchorInView = !isBelowBottom && !isAboveTop;

      // // Set query decade if decade is in view
      // if (queryChangingActive.value) {
      //   if (anchorInView) {
      //     emit("anchorInView", props.anchor);
      //   } else if (!anchorInView && anchorWasInView) {
      //     emit("removeAnchorFromView", props.anchor);
      //   }
      // }
    } else {
      fixAnchor.value.bottom = false;
      fixAnchor.value.top = false;
    }
  }
);

/**
 * listener sullo scroll
 * in base a un id prendo la sezione e segue la posizione y
 */

// function animateSection() {
//   const animationDuration = 1000;

//   window.requestAnimationFrame(() => {
//     document
//       .getElementById("wrapper")
//       .animate(
//         [
//           { transform: "translateY(0)" },
//           { transform: "translateY(-50px)" },
//           { transform: "translateY(0)" },
//         ],
//         animationDuration
//       );
//   });

//   // setTimeout(() => {
//   // queryChangingActive.value = true;
//   // }, animationDuration);
// }

function animateAllSection(value) {
  const yOffset = 0;
  const element = document.getElementById(value);
  const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

  // document.getElementById(value).scrollIntoView({ behavior: "smooth" });

  window.scrollTo({ top: y, behavior: "smooth" });
}

function scroll(value) {
  // queryChangingActive.value = false;
  router.push({
    path: "/",
    query: { ...route.query, decade: props.anchor },
  });

  animateAllSection(value);
}

function formatAnchor(anchor) {
  if ($tvaMq.value === "mobile" || $tvaMq.value === "tablet") {
    return `'${anchor.toString().slice(2)}`;
  }
  return `${t("general.years")} '${anchor.toString().slice(2)}`;
}

function getAnchorTopOffset(anchorIndex) {
  return (
    topAnchorsPadding.value + anchorHeight.value * (anchorIndex + 1) + "px"
  );
}

function getAnchorBottomOffset(anchorIndex) {
  return (
    bottomAnchorsPadding.value +
    anchorHeight.value * (props.anchors.length - anchorIndex) +
    "px"
  );
}
</script>

<style lang="scss" scoped>
.decade-section {
  position: relative;
  &__background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: -1;
  }

  &.hidden {
    visibility: hidden;
  }

  &__anchor {
    text-align: right;
    color: $scala-grigi-gray_2;
    padding-right: 3vw;
    width: fit-content;
    position: absolute;
    right: 0;
    top: -0.25rem;
    z-index: 1;
    transition: transform 0.5s, opacity 0.5s;

    @include link-m;

    &::before {
      content: "";
      position: absolute;
      height: 1px;
      width: 100vw;
      background-color: $primary-yellow;
      transform-origin: right center;
      transition: opacity 0.5s, transform 0.5s;
      bottom: 0;
      right: 0;
    }

    .mobile &,
    .tablet & {
      top: -1.65rem;
      right: 1rem;
      border: 1px solid $scala-grigi-gray-3;
      padding: 2px toRem(10);
      border-radius: 100px;

      &::before {
        bottom: -0.5rem;
        right: -1rem;
      }
    }

    .tablet & {
      top: -1.1rem;
    }

    &.hide-anchor {
      opacity: 0;
    }

    &.fix-anchor-bottom,
    &.fix-anchor-top {
      position: fixed;
      color: $scala-grigi-gray_3;

      &::before {
        opacity: 0;
        transform: scaleX(0);
      }
    }

    &.fix-anchor-bottom {
      top: initial;
      bottom: var(--fixed-distance-bottom);
    }

    &.fix-anchor-top {
      top: var(--fixed-distance-top);
    }
  }

  &__list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    // grid-row-gap: 48px; Previous
    grid-row-gap: toRem(29);
    grid-column-gap: 14.5px;
    padding: toRem(28) $right-anchors-width toRem(1) toRem(30);

    &.column {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

.tablet,
.mobile {
  .decade-section {
    &__list {
      padding: toRem(27) toRem(112) 0px toRem(30);

      grid-column-gap: 6px;
      grid-row-gap: toRem(27);
    }
  }
}

.mobile {
  .decade-section {
    &__list {
      padding: toRem(6) toRem(66) toRem(0) toRem(14);
      grid-template-columns: repeat(2, 1fr);
      grid-row-gap: 6px;
      grid-row-gap: toRem(6);

      &.column {
        grid-template-columns: repeat(1, 1fr);
      }
    }
  }
}
</style>
